import { render } from "./OfficesViewId.vue?vue&type=template&id=7864b4e2"
import script from "./OfficesViewId.vue?vue&type=script&lang=js"
export * from "./OfficesViewId.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__